module.exports = __webpack_public_path__ + "img/accessory_shirt_12.f7c2a633.svg";